import { render } from "./courseAnalyseCreate.vue?vue&type=template&id=12136184&scoped=true"
import script from "./courseAnalyseCreate.vue?vue&type=script&lang=js"
export * from "./courseAnalyseCreate.vue?vue&type=script&lang=js"

import "./courseAnalyseCreate.vue?vue&type=style&index=0&id=12136184&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12136184"]])

export default __exports__